const SAVE_DISPOSITION_PAYMENT = 'SAVE_DISPOSITION_PAYMENT'
const SET_DISPOSITION_PAYMENT_SAVE_STATUS = 'SET_DISPOSITION_PAYMENT_SAVE_STATUS'
const SET_DISPOSITION_PAYMENT_DATA = 'SET_DISPOSITION_PAYMENT_DATA'

export {
    SAVE_DISPOSITION_PAYMENT,
    SET_DISPOSITION_PAYMENT_SAVE_STATUS,
    SET_DISPOSITION_PAYMENT_DATA
}